import { base_contentBackground } from 'ext-ui/style/colors'
import React from 'react'
import * as style from 'src/app/CardFeedCreate/CardFeedCreate.style'
import SvgCheckNew from 'src/components/Svgs/SvgCheckNew'
import { useTranslate } from 'src/localization/Trns'

import type { WizardStep } from './CardFeedCreate'

interface StepperProps {
  currentStep: WizardStep
  // Jump back to an already-completed step. Active/upcoming steps are not
  // interactive, so the Stepper only invokes this for completed steps.
  onStepSelect: (step: WizardStep) => void
}

const STEPS: { step: WizardStep; key: string }[] = [
  { step: 1, key: 'Contact Bank' },
  { step: 2, key: 'Enter Feed Details' },
  { step: 3, key: 'Review Enrollment Terms' },
]

const Stepper: React.FC<StepperProps> = ({ currentStep, onStepSelect }) => {
  const translate = useTranslate()

  return (
    <nav aria-label={translate('Card Feeds enrollment progress')}>
      <h2 css={style.stepperTitle}>{translate('Get Started')}</h2>
      <ol css={style.stepperList} data-testid="card-feed-create-stepper">
        {STEPS.map(({ step, key }) => {
          const isCompleted = step < currentStep
          const isActive = step === currentStep
          const liClassName = isActive ? 'active' : undefined

          const badge = isCompleted ? (
            <span css={style.stepBadgeCompleted} aria-hidden="true">
              <SvgCheckNew
                stroke={base_contentBackground}
                width={14}
                height={14}
              />
            </span>
          ) : isActive ? (
            <span css={style.stepBadgeActive} aria-hidden="true">
              {step}
            </span>
          ) : (
            <span css={style.stepBadgeUpcoming} aria-hidden="true">
              {step}
            </span>
          )

          const label = <span className="step-label">{translate(key)}</span>

          return (
            <li
              key={step}
              css={style.stepperItem}
              className={liClassName}
              aria-current={isActive ? 'step' : undefined}
              data-testid={`card-feed-create-step-${step}`}
              data-state={
                isCompleted ? 'completed' : isActive ? 'active' : 'upcoming'
              }
            >
              {isCompleted ? (
                <button
                  type="button"
                  css={style.stepperStepButton}
                  onClick={(): void => onStepSelect(step)}
                  aria-label={translate('Go back to ${stepName}', {
                    stepName: translate(key),
                  })}
                  data-testid={`card-feed-create-step-${step}-nav`}
                >
                  {badge}
                  {label}
                </button>
              ) : (
                <>
                  {badge}
                  {label}
                </>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Stepper
